<template>
  <div class="post__normal">
    <TestvPostBanner
      class="comp__TestvPostBanner"
      :post="post"
      :total="total"
      @scrollToComment="scrollToComment"
    />
    <ss-article-body
      class="post"
      type="normal"
      :terminalType="terminalType"
      :articleInfo="post"
      :isLogin="Boolean(isLogin)"
      :userInfo="userInfo"
      :whitelist="setting.external_links_whitelist"
      :SEO="SEO"
    />

    <div class="post__comments__head">
      <div class="comment__count"><IconComment class="icon__comment"/><span>{{ total }}</span></div>
      <div class="title">{{ post.title }}</div>
    </div>

    <PostComment
      ref="comments"
      :articleInfo="post"
      articleType="paid"
      :comments="comments"
    />

    <SSLoading
      :loading="loading"
      :loadEnd="loadEnd"
      :noDataAvailable="!comments.length"
      noDataAvailableText=""
      loadEndText="没有更多数据了"
    />

    <footer>
      <TestvFooter class="comp__TestvFooter"/>
    </footer>
  </div>
</template>

<script>
import postMixin from '../post-mixin.js'
import TestvPostBanner from '@/components/TestvPostBanner/index.vue'
import PostComment from '../_components/PostComment/index.vue'
import TestvFooter from '@/components/TestvFooter/index.vue'

export default {
  name: 'PostNormal',

  components: {
    TestvPostBanner,
    PostComment,
    TestvFooter
  },

  mixins: [postMixin]
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.post {
  >>> .articleWidth-content {
    max-width: 644px;
    padding: 0 20px;
    margin: 32px auto;
    @media (min-width: $screen-md) {
      padding: 0px;
    }
    video {
      height: auto!important;
    }
  }
  >>> .article-side {
    display: none;
  }
}

.comp__TestvPostBanner {
  max-width: 644px;
  margin: auto;
}

.post__comments__head {
  display: none;
  @media (min-width: $screen-md) {
    display: flex;
  }
  justify-content: space-between;
  align-items: center;
  max-width: 644px;
  padding:  0 20px;
  margin: 30px auto 16px;
  .comment__count {
    font-size: 32px;
    font-weight: 500;
    font-family: "DottedSongtiSquare";
    display: flex;
    align-items: center;
    column-gap: 4px;
    .icon__comment {
      width: 40px;
      height: 40px;
    }
  }
  .title {
    font-size: 13px;
    color: var(--dark-bwb-3);
    max-width: 185px;
  }
}

footer {
  position: relative;
  .comp__TestvFooter {
    justify-content: center;
    text-align: center;
    >>> .testv__footer__left {
      display: none;
      @media (min-width: $screen-xl) {
        display: block;
      }
      position: absolute;
      left: 0;
      bottom: 0;
      .logo {
        left: 12px;
        bottom: 12px;
        right: auto;
      }
    }
    >>> .testv__footer {
      .LogoTestv {
        display: inline-block;
        width: 128px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
